<template>
    <q-page class="q-pa-md">
        <freshdesk_tickets_list ref="freshdesk_tickets_list"></freshdesk_tickets_list>
    </q-page>
</template>

<script>
    export { default } from './freshdeskticketsapplicationviewmodel-custom-screen.js'
</script>